import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { useOrgStore } from '@/stores/org-store';
import { listArtifacts } from '@/services/artifacts/list-artifacts';
import type {
  ArtifactListResponse,
  ListArtifactsParams,
} from '@/types/artifacts';

export const ARTIFACTS_QUERY_KEY = 'artifacts';

export const artifactsListQueryKey = (orgId: string | undefined) =>
  [ARTIFACTS_QUERY_KEY, orgId] as const;

export const useListArtifacts = (
  params: ListArtifactsParams = {},
  options?: {
    enabled?: boolean;
    /** For callers waiting on rows that are still being written. */
    refetchInterval?: UseQueryOptions<
      ArtifactListResponse,
      Error
    >['refetchInterval'];
  },
) => {
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  return useQuery<ArtifactListResponse, Error>({
    queryKey: [...artifactsListQueryKey(orgId), params],
    queryFn: () => listArtifacts(orgId!, params),
    enabled: !!orgId && (options?.enabled ?? true),
    staleTime: 30_000,
    retry: 1,
    refetchInterval: options?.refetchInterval,
  });
};
